export type ResolveActiveStepIndexParams = {
  elapsedMs: number;
  stepCount: number;
  stepIntervalMs: number;
  stepDurationWeights?: number[];
};

export function resolveActiveStepIndex({
  elapsedMs,
  stepCount,
  stepIntervalMs,
  stepDurationWeights,
}: ResolveActiveStepIndexParams): number {
  if (stepCount <= 0) {
    return 0;
  }

  if (
    !stepDurationWeights ||
    stepDurationWeights.length !== stepCount ||
    stepDurationWeights.some((weight) => weight <= 0)
  ) {
    return Math.min(Math.floor(elapsedMs / stepIntervalMs), stepCount - 1);
  }

  const totalWeight = stepDurationWeights.reduce((sum, weight) => sum + weight, 0);
  const estimatedTotalMs = stepCount * stepIntervalMs;
  let cumulativeMs = 0;

  for (let index = 0; index < stepCount; index += 1) {
    cumulativeMs += (stepDurationWeights[index] / totalWeight) * estimatedTotalMs;
    if (elapsedMs < cumulativeMs) {
      return index;
    }
  }

  return stepCount - 1;
}
